import styled from 'styled-components'

export const Vertical = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: flex-start;
`
